import React, { useState } from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Box, Button, DataTable } from '../../../../../common/components';
import './styles.scss';
import formatDate from '../../../../../helpers/formatDate';
import { actions } from '../../../../dashboard/redux/dashboardActions';
import { refreshData } from '../../../../../common/components/DataTable/redux/dataTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../../../layout/components';
import { toastr } from 'react-redux-toastr';

const Reminders = ({ actions, dispatch }) => {
  const [notesToClear, setNotesToClear] = useState([]);
  const [availableNoteIds, setAvailableNoteIds] = useState([]);

  const clearReminder = (noteId) => () => {
    Promise.resolve(actions.clearReminder(noteId)).then(() => {
      refreshList();
    });
  };

  const refreshList = () => {
    dispatch(refreshData('reminders'));
  };

  const formatAction = (cell, note) => {
    return (
      <div>
        <span onClick={clearReminder(note.id)}>Clear</span>
        &nbsp;|&nbsp;
        <Link
          to={{
            pathname: note.forward_url,
            state: { tab: 'notes' },
          }}
          onlyActiveOnIndex
        >
          View
        </Link>
      </div>
    );
  };

  const getNoteCheckbox = (cell, note) => {
    // Get a list of available notes.
    let ids = availableNoteIds;
    if (!ids.includes(note.id)) {
      ids.push(note.id);
      setAvailableNoteIds(ids);
    }
    // Used for Select All.
    const checkboxChecked = (noteId) => {
      if (notesToClear.includes(noteId)) {
        return true;
      }
    };

    return (
      <div>
        <input
          type="checkbox"
          style={{
            minHeight: '24px',
            minWidth: '24px',
            marginLeft: '5%',
          }}
          checked={checkboxChecked(note.id)}
          id={note.id}
          onClick={(e) => setSelection(e, note.id)}
        />
      </div>
    );
  };

  // On selection, aad note id to list of all ids to be cleared.
  const setSelection = (e, noteId) => {
    let notes = notesToClear;

    if (e.target.checked) {
      notes.push(noteId);
      setNotesToClear(notes);
    } else {
      notes = notes.filter((id) => id !== noteId);
      setNotesToClear(notes);
    }
  };

  // Clear selected notes.
  const handleClearSelected = () => {
    if (notesToClear.length === 0) {
      toastr.error('Whoops!', 'No reminders selected');
      return;
    }

    let promises = [];
    promises.push(actions.clearSelectedReminders(notesToClear));

    // Reset notes ids to clear and refresh list.
    Promise.all(promises).then(() => {
      setNotesToClear([]);
      refreshList();
    });
  };

  return (
    <Box>
      <DataTable
        source="reminders/all"
        name="reminders"
        showTotal
        autoFilters={[
          { type: 'filter[reminders]', value: true },
          { type: 'sort', value: 'reminder_at' },
        ]}
      >
        <TableHeaderColumn dataField="id" isKey hidden />
        <TableHeaderColumn
          width={'15%'}
          dataField="reminder_at"
          dataFormat={formatDate}
          dataSort
        >
          Reminder Date
        </TableHeaderColumn>
        <TableHeaderColumn
          width={'15%'}
          dataField="noted_at"
          dataFormat={formatDate}
          dataSort
        >
          Created Date
        </TableHeaderColumn>
        <TableHeaderColumn width={'40%'} dataField="content">
          Content
        </TableHeaderColumn>
        <TableHeaderColumn width={'15%'} dataField="created_by_name">
          Created by
        </TableHeaderColumn>
        <TableHeaderColumn width={'15%'} dataField="Select" dataFormat={getNoteCheckbox}>
          Select
        </TableHeaderColumn>
        <TableHeaderColumn width={'10%'} dataField="Actions" dataFormat={formatAction}>
          Actions
        </TableHeaderColumn>
      </DataTable>

      <Row>
        <Col sm={12}>
          <InternalButtonBar
            buttons={[
              {
                permissions: ['content_management.edit'],
                button: (
                  <Button
                    handleClick={handleClearSelected}
                    className="pull-right"
                    bsStyle="primary"
                    label="Clear selected"
                  />
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </Box>
  );
};

export default connect(
  null,
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    dispatch,
  }),
)(Reminders);
